<script>
	import { fly } from 'svelte/transition';


    export let category;
	
</script>


<div id="category-details" class="category-container" class:event-none={category === null} on:outrostart={() => { document.getElementById('category-details').classList.add('event-none') }} on:outroend in:fly={{ duration: 600, y: 200}} out:fly={{duration: 800, x: 300}}>
    {@html category.details}
</div>

<style>
    .category-container {
        z-index: 1;
		display: inline-block;
        text-align: left;
        padding: 15px 20px 15px 20px;
        font-size: 3vw;
        width: 100%;
        background-color: var(--color-grey-light);
        height: calc(100% - 30px);
	}

    .category-container.event-none {
        pointer-events: none;
        user-select: none;
    }

    @media only screen and (min-width: 768px) {
        .category-container {
            font-size: 1.3vw;
            line-height: 1.5vw;
            padding: 35px 40px 35px 40px;
            height: calc(100% - 70px);
        }
    }

    @media only screen and (min-width: 1850px) {
        .category-container {
            font-size: 24px;
        }
    }
</style>